import { createReducer, on } from '@ngrx/store';
import { reset, set, update } from './invitation.actions';
import { IEBInvitation } from '@shared/models/entities/invitation.interface';

export interface StateInvitationType {
  data: IEBInvitation | null;
}

export const initialState: StateInvitationType = {
  data: null,
};

export const invitationReducer = createReducer(
  initialState,
  on(set, (state, { invitation }) => ({
    ...state,
    data: invitation,
  })),
  on(update, (state, { invitation }) => ({
    ...state,
    data: invitation,
  })),
  on(reset, (_) => initialState),
);
